import { Button, Flex, Heading, Icon, Stack, Text } from '@chakra-ui/react';
import { CountdownTimer, Divider } from '@diamond/shared/ui';
import { CheckOutlined, ContentCopy } from '@mui/icons-material';

interface OrderDetailHeaderProps {
  transactionId?: string;
  hasCopiedTransactionId: boolean;
  onCopyTransactionId: () => void;
  isWaitingForPayment: boolean;
  expiredAt?: number | null;
  onScrollToPaymentProof?: () => void;
  title?: string;
}

export const OrderDetailHeader = ({
  transactionId,
  hasCopiedTransactionId,
  onCopyTransactionId,
  isWaitingForPayment,
  expiredAt,
  onScrollToPaymentProof,
  title = 'Detail Pesanan',
}: OrderDetailHeaderProps) => {
  return (
    <>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex
          w={{ base: 'full', md: 'unset' }}
          gap={{ base: 'unset', md: '2' }}
          justifyContent="space-between"
        >
          <Flex alignItems="center">
            <Heading fontSize={{ base: 'lg', md: '24px' }} fontWeight="600">
              {title}
            </Heading>
          </Flex>
          <Flex alignItems="center">
            <Heading
              as="h5"
              fontSize={{ base: 'lg', md: '24px' }}
              fontWeight="semibold"
              textColor="#34C759"
            >
              {transactionId ?? ''}
            </Heading>
            <Button
              id="copy-transaction-id"
              variant="unstyled"
              color="gray.75"
              onClick={onCopyTransactionId}
            >
              {hasCopiedTransactionId ? (
                <Icon
                  as={CheckOutlined}
                  boxSize={{ base: '20px', md: '24px' }}
                />
              ) : (
                <Icon as={ContentCopy} boxSize={{ base: '20px', md: '24px' }} />
              )}
            </Button>
          </Flex>
        </Flex>
        {isWaitingForPayment && (
          <Stack
            display={{ base: 'none', md: 'flex' }}
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap="2.5"
          >
            <Text
              textDecor="underline"
              fontSize="sm"
              fontWeight="medium"
              color="#0000A3"
              cursor="pointer"
              onClick={onScrollToPaymentProof}
            >
              Unggah Bukti Transfer
            </Text>
            {expiredAt && <CountdownTimer endTime={expiredAt} />}
          </Stack>
        )}
      </Flex>
      <Divider
        display={{ base: 'none', md: 'block' }}
        border="3px solid gray.33"
      />
    </>
  );
};
